import { Component, input } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { TableRowData } from '@app/shared/models/table-data-types';
import {
    ColumnConfig,
    ColumnValue,
} from '@app/shared/services/view-configs/column-creator';

@Component({
    selector: 'app-consignor-name-with-exchange',
    standalone: true,
    imports: [MatIconModule, MatTooltipModule, TranslateModule],
    template: `
        <span class="tw-flex tw-items-center">
            {{ consignorName }}
            @if (hasConsignorLoadCarrierExchange) {
                <mat-icon
                    [matTooltip]="
                        'TOOLTIPS.CARRIER-EXCHANGE-CHECKOUT' | translate
                    "
                    class="tw-m-2"
                    svgIcon="carrier-exchange">
                </mat-icon>
            }
        </span>
    `,
})
export class ConsignorNameWithExchangeComponent {
    value = input<ColumnValue>();
    row = input<TableRowData>();
    column = input<ColumnConfig>();
    index = input<number>(0);
    item = input<TableRowData>(); // legacy alias
    parentRow = input<TableRowData>(); // for expanded rows

    get rowData(): TableRowData | undefined {
        return this.row() || this.item();
    }

    get consignorName(): string {
        return (this.rowData as any)?.consignorName || this.value() || '';
    }

    get hasConsignorLoadCarrierExchange(): boolean {
        return (
            !!(this.rowData as any)?.consignorLoadCarrierExchange ||
            !!(this.parentRow() as any)?.consignorLoadCarrierExchange
        );
    }
}
